import { useCallback, useState } from "react";
import { useDispatch } from "react-redux";
import axios from "../../services/axiosConfig";
import { getUserProfile } from "../../Redux/userSlice";

export default function useInstagramInsightsSync() {
  const dispatch = useDispatch();
  const [syncing, setSyncing] = useState(false);

  const syncInstagramInsights = useCallback(async () => {
    setSyncing(true);
    try {
      await axios.get("/auth/instagram/refresh-insights", {
        withCredentials: true,
      });
      await dispatch(getUserProfile());
      return { success: true };
    } catch (error) {
      console.error("Error refreshing insights:", error);
      return {
        success: false,
        message: "⚠️ Failed to refresh insights. Try again.",
      };
    } finally {
      setSyncing(false);
    }
  }, [dispatch]);

  return { syncing, syncInstagramInsights };
}
